<template>
  <nav class="header-nav">
    <div class="container">
      <router-link :class="{'active': activeLink == 'safety'}" to="/safety">富地滋的品質</router-link>
      <router-link :class="{'active': activeLink == 'manufacturing'}" to="/safety/manufacturing">製品的安全性</router-link>
      <router-link :class="{'active': activeLink == 'patents'}" to="/safety/patents">專利權資訊</router-link>
      <router-link :class="{'active': activeLink == 'insurance'}" to="/safety/insurance">產品責任保險</router-link>
    </div>
  </nav>
</template>
<script>
export default {
  name: "SafetyHeaderNav",
  props: ["activeLink"],
};
</script>
